import { SubscriptionApp } from '@focuslee/shared';
import { Stack } from '@mui/material';
import { Caption, Text } from '@telegram-apps/telegram-ui';
import { useTranslation } from 'react-i18next';
import { CommonIcon } from '../components/CommonIcon';

export function PremiumFeatures({ hasPremium, app }: { hasPremium: boolean; app: SubscriptionApp }) {
    const { t } = useTranslation('subscription');
    const features: { id: 'aiMealLogging' | 'healthInsights' | 'inBodyScan' | 'focusLee' | 'voice' | 'healthLee'; icon: string }[] =
        app === SubscriptionApp.healthlee
            ? [
                  { id: 'aiMealLogging', icon: 'photo_camera' },
                  { id: 'healthInsights', icon: 'insights' },
                  { id: 'inBodyScan', icon: 'monitor_weight' },
                  { id: 'focusLee', icon: 'graphic_eq' },
              ]
            : [
                  { id: 'voice', icon: 'graphic_eq' },
                  { id: 'healthLee', icon: 'favorite' },
              ];
    return (
        <Stack spacing={1.5}>
            <Text style={{ fontSize: 13, fontWeight: 700, color: 'var(--tg-theme-hint-color)' }}>
                {t(hasPremium ? 'includedActive' : 'included')}
            </Text>
            {features.map(feature => (
                <Stack key={feature.id} direction="row" spacing={1.5} alignItems="flex-start">
                    <CommonIcon icon={feature.icon} type="filled" size={22} color="var(--tg-theme-link-color)" />
                    <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                        <Text style={{ fontSize: 14, fontWeight: 700 }}>{t(`features.${feature.id}.title`)}</Text>
                        <Caption style={{ color: 'var(--tg-theme-hint-color)', fontSize: 12, lineHeight: 1.4 }}>
                            {t(`features.${feature.id}.description`)}
                        </Caption>
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
}
